import React, { useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  useUpdate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function QuienesSomosEdit(props: any) {
  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'fg-quienes-somoss';

  useEffect(() => {
    document.title = 'Editar Quienes Somos';
  }, []);

  const handleSubmit = async (data: any) => {
    try {
      const payload: Record<string, any> = {
        descripcion: data.descripcion,
        directorio: data.directorio,
        detalle: data.detalle,
        legal: data.legal,
      };

      update(resourceName, { id: data.id, data: payload }, {
        onSuccess: () => {
          notify('Quienes Somos actualizado con éxito', { type: 'success' });
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al actualizar', { type: 'error' });
    }
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput
          source="descripcion"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <RichTextInput
          source="directorio"
          label="Directorio"
          format={blocksToHtml}
          parse={htmlToBlocks}
          fullWidth
        />
        <RichTextInput
          source="detalle"
          label="Detalle"
          format={blocksToHtml}
          parse={htmlToBlocks}
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
}

export default QuienesSomosEdit;
